import {AbstractControlOptions, AsyncValidatorFn, FormControl, ValidatorFn} from '@angular/forms';
import * as moment from 'moment/moment';

export interface AppDatePartFormDataInterface {
    format?: string,
    state?: string,
    default?: Date;
}

export class AppDateFormControl extends FormControl {
    constructor(
        date: AppDatePartFormDataInterface,
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
    ) {
        super(AppDateFormControl.#getFormState(date), validatorOrOpts, asyncValidator);
    }

    static #getFormState(data: AppDatePartFormDataInterface): any {
        if (undefined === data.state && undefined === data.default) {
            return '';
        }

        if (undefined !== data.format) {
            return moment(data.state ?? data.default).set(data.default ? {hour: 9, minute: 0, second: 0, millisecond: 0} : {}).format(data.format);
        }

        return moment(data.state ?? data.default).set(data.default ? {hour: 9, minute: 0, second: 0, millisecond: 0} : {}).toISOString();
    }
}
